<template>
    <div id="app">
        <disconnected v-if="currentConnectionAttempt > 0" :current-connection-attempt="currentConnectionAttempt"/>
        <alert-box v-if="alertShown" :content="alertContent" :config="alertConfig" @close="closeDialog"/>
        <div class="header">
            <div class="logo" :class="{fixed: !isAuthenticated}">
                <img :src="require('@/assets/images/logo.svg')" alt="">
            </div>
            <drop-down v-if="isAuthenticated" align="right" :offset-top="5">
                <template v-slot:actionContent="state">
                    <span :class="[state.dropDownShown ? 'taxi-close' : 'taxi-hamburger']"></span>
                </template>
                <a href="#" @click.prevent="logOut"  class="dropdown-link">გასვლა</a>
            </drop-down>

        </div>

        <router-view/>
        <div class="footer">
            Developed by <span>MOTUS</span> tracking systems
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {AUTH_LOGOUT} from "./store/types";
    import Disconnected from "./components/Disconnected";
    import AlertBox from "./components/AlertBox";
    import DropDown from "./components/DropDown";
    export default {
        data(){
            return {
                alertShown: false,
                alertConfig: null,
                alertContent: null
            }
        },
        methods:{
            closeDialog(){
                this.alertShown = false;
                this.alertConfig = null;
                this.alertContent = null;
            },

            logOut(){
                if(this.tripData){
                    this.$eventBus.$emit('showAlert', {
                        content: 'გასვლა შეუძლებელია. გთხოვთ დაასრულოთ მგზავრობა',
                        config: {type: 'error'}
                    });
                }else {
                    this.$store.dispatch(AUTH_LOGOUT).then(()=>{
                        this.$router.push({name: 'authorization'})
                    });
                }
            }
        },
        computed:{
            ...mapGetters(['isAuthenticated', 'tripData']),
            currentConnectionAttempt(){
                return this.$store.state.trip.currentConnectionAttempt;
            },
        },
        components:{
            Disconnected,
            AlertBox,
            DropDown
        },
        created() {
            this.$eventBus.$on('showAlert', alertData =>{
                if(alertData){
                    this.alertConfig = alertData.config;
                    this.alertContent = alertData.content;
                    this.alertShown = true;
                }
            })
        }
    }
</script>

<style lang="scss">
    @import "./assets/css/common.scss";
    @import './assets/css/fonts.css';
    @import './assets/css/icons.css';

    * {
        box-sizing: border-box;
    }

    html{
        width: 100%;
        height: 100%;
    }

    body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-family: 'dejavu_sansbook';
    }

    button,
    button:active,
    input:focus,
    textarea:focus,
    tr, tr:active {
        outline: none !important;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        text-shadow: none !important;
    }

    input, button{
        font-family: 'dejavu_sansbook';
    }

    #app {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        color: $text-color;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 18px;
            background-color: #E5E5E5;
            color: $white;
            font-size: .85rem;
            background-image: url("assets/images/stripes.svg");
            background-repeat: no-repeat;
            background-size: auto 100%;

            .logo {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                max-width: 95%;

                img {
                    width: 38%;
                    margin-left: 15px;
                }

                &.fixed{
                    margin-right: 6%;
                }
            }

            a {
                color: $primary-color;
            }

            .dropdown-link {
                color: $gray-8;
                text-decoration: none;
                cursor: none;
            }
        }

        .footer {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px;
            background-color: $primary-color;
            color: $gray-3;
            font-size: .7rem;
            span{
                color: $white;
                margin: 0 5px;
                font-size: .85rem;
            }
        }
    }
</style>
